export function getKeysAndValues(obj) {
  // Getting keys
  const keys = Object.keys(obj);

  // Getting values
  const values = Object.values(obj);

  return { keys, values };
}
